import BaseModel from "@/api/models/BaseModel";
import store from '@/store';

/**
 * CartHandler
 * @param {Course} item*
 * @param {Boolean} persist
 */
export default class CartHandler extends BaseModel{

  constructor({
    item,
    persist
  }) {
    super();
    
    this.item = item || null;
    this.persist = persist || false;
  }

  getIdentifier() {
    return ![null, undefined, ''].includes(this.item.uuid) ? this.item.uuid : this.item.id;
  }

  isItemInCart() {
    const cartItems = store.state.cart.items;

    for (let item of cartItems) {
      const identifier = ![null, undefined, ''].includes(item.uuid) ? item.uuid : item.id;
      if (identifier == this.getIdentifier()) {
        return true;
      }
    }

    return false;
  }
}